<div class="relative bg-white">
  <lib-icon
    name="search"
    class="absolute top-1/2 left-4 -translate-y-1/2 text-gray-400"
  ></lib-icon>
  <lib-input-field
    [placeholder]="placeholder()"
    type="text"
    name="search-input"
    className="pl-11"
    (input)="onSearch($event)"
    class="font-title"
    [ngModel]="value()"
  >
  </lib-input-field>
</div>